export const environment = {
  production: false,
  domain:"https://wa-be-dsc-rmt-dev.azurewebsites.net",
  APP_REG_TENANT_ID: "cd99fef8-1cd3-4a2a-9bdf-15531181d65e",
  APP_REG_CLIENT_ID: "28706c51-8add-42d3-a979-becc13ddd4ec",
  APP_REG_SCOPE: "api://28706c51-8add-42d3-a979-becc13ddd4ec/rate-management_user_admin_acess",
  APP_REG_REDIRECT_URL: "https://www.fi2m-dev.rmt.dhl.com",//"https://wa-ui-dsc-rmt-dev.azurewebsites.net" ,//"https://www.fi2m-dev.rmt.dhl.com"
  AUTHTOKEN_FOR_UM_PORTAL : 'U2FsdGVkX18IkuY0mpnJTXhUkiHO4MwDXvjx4iS+rLwU2FsdGVkX19Cj6ZlUUmhoJH4Jk48Q1emfzvyTsJ5NEN3RHh/aNb/ciiHOc/ooxoH',
  AUTHTOKEN_KEY : 'RMT-Security-token-for-Authentication-version-0.1',
  CSRF_TOKEN_NAME : "XSRF-TOKEN",
  TOKEN_FOR_SSO_AUTH:'rmt_tokenfor-auth-001-for-SEcurity'

};